import React from 'react';
import { Button, makeStyles, Skeleton, SkeletonItem } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import { useHistory, useParams } from 'react-router-dom';
import CompanyHeaderItems from '../../../utils/types/CompanyHeaderItems';
import ICompany from '../../../utils/types/ICompany';
import { ICompanyCodeParams } from '../../common/ParamTypes';
import PivotHeader from '../../common/headers/PivotHeader';
import { iconButtonStyles } from '../../../app/common/styles/CommonStyleObjects';

const useStyles = makeStyles({
  skeleton: {
    width: '400px',
  },
});

interface ICompanyHeaderProps {
  company: ICompany;
  showBackToListButton?: boolean;
}

const CompanyHeader = (props: ICompanyHeaderProps): JSX.Element => {
  const { company, showBackToListButton } = props;
  const { sapName, physicalCountry } = company || {};
  const { companyCode } = useParams<ICompanyCodeParams>();
  const history = useHistory();
  const styles = useStyles();

  // mobile menu onClick
  // render header title
  // We need to have some sort of shimmer on load
  const renderHeaderTitle = (): JSX.Element => {
    if (companyCode && sapName) {
      return (
        <h1>
          {showBackToListButton && (
            <Button
              appearance="subtle"
              icon={<ArrowLeftRegular color={iconButtonStyles.color} />}
              style={{ marginRight: 10 }}
              title="Back to companies list"
              aria-label="Back to companies list"
              onClick={(): void => {
                history.push(`/companies/`);
              }}
            />
          )}

          {`${companyCode} - ${sapName} (${physicalCountry})`}
        </h1>
      );
    }
    return (
      <Skeleton className={styles.skeleton} aria-label="Loading company header">
        <SkeletonItem />
      </Skeleton>
    );
  };

  return (
    <PivotHeader
      getHeaderTitle={renderHeaderTitle}
      pivotHeaderItems={CompanyHeaderItems}
      baseUri={`/companies/${companyCode}`}
      ariaLabel="Navigation for Company Details"
      defaultActiveSegment="company-information"
      enableActiveTabPanelControls
    />
  );
};
export default CompanyHeader;
